import { Button } from "ui/components/button";
import { Label } from "ui/components/label";
import useTableFilters from "@/hooks/useTableFilters";
import { EMPLOYEE_FILTERS } from "components/employee/constants";
import UserCombobox from "components/directus/combobox/user";
import ProjectCombobox from "components/directus/combobox/project";
import SelectStatus from "components/select/status";

export default function OverrunJobsReportsFilters({
    filters,
    setFilters,
    setIsOpen,
    isOpen,
    defaultFilters,
    clearFilters,
}) {
    const {
        localFilters,
        applyFilters,
        clearLocalFilters,
        handleSetLocalFilters,
    } = useTableFilters({
        filters,
        setFilters,
        setIsOpen,
        clearFilters,
        initialFilters: {
            jobCoordinatorId: undefined,
            projectCoordinatorId: undefined,
            accountManagerId: undefined,
            salesCoordinatorId: undefined,
            projectId: undefined,
            status: undefined,
            ...defaultFilters,
        },
    });

    return (
        <div className="w-full p-4 space-y-4">
            <div>
                <Label className="mb-2 text-sm">Job Coordinator</Label>
                <UserCombobox
                    value={localFilters?.jobCoordinatorId}
                    onChange={(selectedItem) =>
                        handleSetLocalFilters({
                            ...localFilters,
                            jobCoordinatorId: selectedItem,
                        })
                    }
                    filter={EMPLOYEE_FILTERS.jobs_coordinating}
                    dependenton={isOpen}
                />
            </div>
            <div>
                <Label className="mb-2 text-sm">Project Coordinator</Label>
                <UserCombobox
                    value={localFilters?.projectCoordinatorId}
                    onChange={(selectedItem) =>
                        handleSetLocalFilters({
                            ...localFilters,
                            projectCoordinatorId: selectedItem,
                        })
                    }
                    filter={EMPLOYEE_FILTERS.projects_coordinating}
                    dependenton={isOpen}
                />
            </div>
            <div>
                <Label className="mb-2 text-sm">Account Manager</Label>
                <UserCombobox
                    value={localFilters?.accountManagerId}
                    onChange={(selectedItem) =>
                        handleSetLocalFilters({
                            ...localFilters,
                            accountManagerId: selectedItem,
                        })
                    }
                    filter={EMPLOYEE_FILTERS.account_manager}
                    dependenton={isOpen}
                />
            </div>
            <div>
                <Label className="mb-2 text-sm">Sales Coordinator</Label>
                <UserCombobox
                    value={localFilters?.salesCoordinatorId}
                    onChange={(selectedItem) =>
                        handleSetLocalFilters({
                            ...localFilters,
                            salesCoordinatorId: selectedItem,
                        })
                    }
                    filter={EMPLOYEE_FILTERS.sales_coordinating}
                    dependenton={isOpen}
                />
            </div>
            <div>
                <Label className="mb-2 text-sm">Project</Label>
                <ProjectCombobox
                    value={localFilters.projectId}
                    hideLabel
                    className="w-full"
                    dependsOn={isOpen}
                    onChange={(selectedItem) =>
                        handleSetLocalFilters({
                            ...localFilters,
                            projectId: selectedItem,
                        })
                    }
                />
            </div>
            <div>
                <Label className="mb-2 text-sm">Status</Label>
                <SelectStatus
                    remove={["draft", "cancelled", "archived", "backlog", "todo"]}
                    collection="jobs"
                    value={localFilters?.status}
                    onChange={(selectedItem) => {
                        handleSetLocalFilters({
                            ...localFilters,
                            status: selectedItem,
                        });
                    }}
                />
            </div>

            {/* Action Buttons */}

            <div className="flex place-self-end gap-4">
                <Button variant="outline" onClick={clearLocalFilters}>
                    Clear
                </Button>

                <Button onClick={() => applyFilters()}>Apply</Button>
            </div>
        </div>
    );
}
